/*
 * Checkbox „Karton ohne Duft“
 * - schreibt den Hinweis an den Anfang der Bestellnotiz (Lieferschein), eigene Notiz der Kundin bleibt erhalten
 * - setzt zusätzlich das Warenkorb-Attribut „Karton ohne Duft = Ja“ als Absicherung
 * - hängt sich in den EliteCart-Drawer ein (über den Kasse-Button)
 * - stellt den Hinweis wieder her, falls ein Notizfeld (Theme oder EliteCart) ihn überschreibt
 */
(function () {
  if (window.__scentOptoutInit) return;
  window.__scentOptoutInit = true;

  var MARKER = 'KARTON OHNE DUFT';
  var ATTR = 'Karton ohne Duft';
  var state = null;
  var busy = false;

  function boxHtml() {
    return (
      '<label class="scent-optout__label">' +
        '<input type="checkbox" class="scent-optout__input">' +
        '<span>Karton ohne Duft versenden<small class="scent-optout__hint">Wir beduften jeden Versandkarton mit unserem Parfum.</small></span>' +
      '</label>'
    );
  }

  function syncBoxes() {
    if (state === null) return;
    document.querySelectorAll('.scent-optout__input').forEach(function (b) { b.checked = state; });
  }

  function injectEliteCart() {
    document.querySelectorAll('.ec-checkout-buttons-container').forEach(function (c) {
      var prev = c.previousElementSibling;
      if (prev && prev.classList.contains('scent-optout--ec')) return;
      var wrap = document.createElement('div');
      wrap.className = 'scent-optout scent-optout--ec';
      wrap.innerHTML = boxHtml();
      c.parentNode.insertBefore(wrap, c);
    });
    syncBoxes();
  }

  function buildNote(note, on) {
    note = (note || '').split(MARKER).join('').trim();
    return on ? (MARKER + (note ? '\n' + note : '')).trim() : note;
  }

  async function getCart() {
    return (await fetch('/cart.js', { credentials: 'same-origin' })).json();
  }

  async function save(on, currentNote) {
    busy = true;
    try {
      var note = buildNote(currentNote, on);
      var attrs = {}; attrs[ATTR] = on ? 'Ja' : '';
      await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: note, attributes: attrs })
      });
      document.querySelectorAll('textarea[name="note"]').forEach(function (t) { t.value = note; });
      if (window.EliteCart && typeof window.EliteCart.refreshCart === 'function') {
        try { await window.EliteCart.refreshCart(); } catch (e) {}
      }
    } finally {
      busy = false;
    }
  }

  // Zustand laden; wurde der Hinweis aus der Notiz gelöscht, das Attribut aber steht noch -> wiederherstellen
  async function loadState() {
    if (busy) return;
    try {
      var cart = await getCart();
      var inNote = (cart.note || '').indexOf(MARKER) !== -1;
      var attrOn = cart.attributes && cart.attributes[ATTR] === 'Ja';
      state = inNote || attrOn;
      syncBoxes();
      if (attrOn && !inNote) await save(true, cart.note);
    } catch (e) {}
  }

  document.addEventListener('change', async function (e) {
    var box = e.target;
    if (!box.classList || !box.classList.contains('scent-optout__input')) return;
    state = box.checked;
    syncBoxes();
    try {
      var cart = await getCart();
      await save(state, cart.note);
    } catch (err) {
      console.error('Duft-Abwahl konnte nicht gespeichert werden', err);
    }
  });

  // EliteCart rendert seinen Drawer dynamisch neu – daher beobachten und bei Bedarf wieder einhängen
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; injectEliteCart(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  function hookEliteCart() {
    if (window.EliteCart && typeof window.EliteCart.onCartChange === 'function') {
      try { window.EliteCart.onCartChange(function () { loadState(); }); } catch (e) {}
      return true;
    }
    return false;
  }
  if (!hookEliteCart()) {
    var tries = 0;
    var iv = setInterval(function () { if (hookEliteCart() || ++tries > 40) clearInterval(iv); }, 250);
  }

  // Theme-Notizfeld: nach dem Bearbeiten prüfen
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.name === 'note' || (e.target.classList && e.target.classList.contains('ec-ordernote-textarea')))) {
      setTimeout(loadState, 800);
    }
  });

  loadState();
  injectEliteCart();
})();
